const DOCUMENT = 'ATTENTION_REQUIRED_LIST_';

const actions = {
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  PROCESS_ACTION: DOCUMENT + 'PROCESS_ACTION',
  LOAD_MULTI_DAY_SUCCESS: DOCUMENT + 'LOAD_MULTI_DAY_SUCCESS',
  SHOW_ASSIGN_MODAL: DOCUMENT + 'SHOW_ASSIGN_MODAL',
  HIDE_ASSIGN_MODAL: DOCUMENT + 'HIDE_ASSIGN_MODAL',
  ASSIGN_MODAL_LOAD_DATA: DOCUMENT + 'ASSIGN_MODAL_LOAD_DATA',
  ASSIGN_MODAL_LOAD_DATA_SUCCESS: DOCUMENT + 'ASSIGN_MODAL_LOAD_DATA_SUCCESS',
  ASSIGN_TO_APPROVER: DOCUMENT + 'ASSIGN_TO_APPROVER',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

  loadData: data => ({
    type: actions.LOAD,
    payload: data,
  }),

  loadDataSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  loadMultiDayDataSuccess: data => ({
    type: actions.LOAD_MULTI_DAY_SUCCESS,
    payload: data,
  }),

  processAction: data => ({
    type: actions.PROCESS_ACTION,
    payload: data,
  }),

  showAssignModal: data => ({
    type: actions.SHOW_ASSIGN_MODAL,
    payload: data,
  }),

  hideAssignModal: data => ({
    type: actions.HIDE_ASSIGN_MODAL,
    payload: data,
  }),

  assignModalLoadData: data => ({
    type: actions.ASSIGN_MODAL_LOAD_DATA,
    payload: data,
  }),

  assignModalLoadDataSuccess: data => ({
    type: actions.ASSIGN_MODAL_LOAD_DATA_SUCCESS,
    payload: data,
  }),

  assignToApprover: data => ({
    type: actions.ASSIGN_TO_APPROVER,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),
};

export default actions;
